var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:['mc-btn--'+_vm.type, 'is-'+_vm.size, _vm.isActive],attrs:{"disabled":_vm.disabled,"type":"button"},on:{"click":_vm._onClick}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


// WEBPACK FOOTER //
// ./src/components/base-btn.vue